export const dict = {
  es: {
    nav: {
      properties: "Propiedades",
      projects: "Proyectos en Plano",
      news: "Noticias",
      favorites: "Favoritos",
      dashboard: "Panel",
      messages: "Mensajes",
      login: "Iniciar sesión",
      register: "Registrarse",
      logout: "Salir",
      publish: "Publicar propiedad",
    },
    bottom: {
      explore: "Explorar",
      publish: "Publicar",
      profile: "Mi Perfil",
    },
    hero: {
      eyebrow: "Bienes raíces República Dominicana",
      title: "Encuentra tu próximo\ninmueble aquí.",
      sub: "Casas, apartamentos, villas y terrenos en toda República Dominicana. Publica, guarda favoritos, contacta al agente — todo en un solo lugar.",
      cta_browse: "Explorar propiedades",
      cta_publish: "Publicar propiedad",
    },
    home: {
      featured: "Destacadas de la semana",
      featured_sub: "Selección curada por nuestros agentes verificados.",
      why_title: "Una plataforma. Dos roles.",
      why_sub: "Diseñada para buscadores serios y agentes que quieren cerrar más rápido.",
      role_buscador_title: "Para buscadores",
      role_buscador_desc: "Explora, guarda favoritos y contacta al agente directamente. Sin comisiones ocultas.",
      role_agente_title: "Para agentes y propietarios",
      role_agente_desc: "Publica tus propiedades con fotos ilimitadas y gestiona tu inventario desde un panel privado.",
      cta_signup: "Crea tu cuenta",
    },
    filters: {
      title: "Filtrar propiedades",
      type: "Tipo",
      any: "Cualquiera",
      transaction: "Operación",
      sale: "Venta",
      rent: "Alquiler",
      min_price: "Precio mín.",
      max_price: "Precio máx.",
      bedrooms: "Habitaciones",
      search: "Buscar por título o dirección",
      apply: "Aplicar filtros",
      clear: "Limpiar",
      results: "resultados",
      view_list: "Lista",
      view_map: "Mapa",
      near_me: "Cerca de mí",
      near_me_active: "Cerca de mí · {km} km",
      near_me_clear: "Quitar",
      near_me_locating: "Localizando…",
      near_me_denied: "No pudimos obtener tu ubicación. Habilita los permisos e intenta de nuevo.",
      near_me_unsupported: "Tu navegador no soporta geolocalización.",
      radius: "Radio",
    },
    property: {
      bedrooms: "Habitaciones",
      bathrooms: "Baños",
      square_meters: "m²",
      type: "Tipo",
      address: "Dirección",
      description: "Descripción",
      agent: "Agente",
      contact: "Contactar por email",
      contact_whatsapp: "Contactar por WhatsApp",
      contact_chat: "Enviar mensaje interno",
      view_phone: "Ver teléfono",
      call: "Llamar",
      save: "Guardar",
      saved: "Guardada",
      published_by: "Publicado por",
      whatsapp_prefill: "Hola, estoy interesado en la propiedad \"{title}\" (ID: {id}). ¿Podemos hablar?",
    },
    types: {
      casa: "Casa",
      apartamento: "Apartamento",
      villa: "Villa",
      local: "Local comercial",
      terreno: "Terreno",
      oficina: "Oficina",
    },
    auth: {
      login_title: "Bienvenido de nuevo",
      login_sub: "Ingresa a tu cuenta de To2casa",
      register_title: "Crea tu cuenta",
      register_sub: "Únete y publica o guarda propiedades",
      email: "Correo electrónico",
      password: "Contraseña",
      name: "Nombre completo",
      phone: "WhatsApp (con código de país)",
      phone_hint: "Opcional para buscadores · Recomendado para agentes",
      role: "Soy",
      role_buscador: "Buscador",
      role_agente: "Agente / Propietario",
      submit_login: "Iniciar sesión",
      submit_register: "Crear cuenta",
      or: "o continúa con",
      google: "Continuar con Google",
      have_account: "¿Ya tienes cuenta?",
      no_account: "¿No tienes cuenta?",
      go_login: "Inicia sesión",
      go_register: "Regístrate",
    },
    dashboard: {
      title: "Panel del agente",
      subtitle: "Gestiona tus publicaciones",
      new: "Nueva propiedad",
      empty: "Aún no has publicado propiedades.",
      edit: "Editar",
      delete: "Eliminar",
      confirm_delete: "¿Eliminar esta propiedad?",
      views: "vistas",
    },
    form: {
      new_title: "Publicar nueva propiedad",
      edit_title: "Editar propiedad",
      f_title: "Título",
      f_price: "Precio",
      f_currency: "Moneda",
      f_address: "Dirección",
      f_bedrooms: "Habitaciones",
      f_bathrooms: "Baños",
      f_sqm: "Metros cuadrados",
      f_type: "Tipo de propiedad",
      f_transaction: "Operación",
      f_description: "Descripción",
      f_photos: "Fotos",
      f_photos_hint: "Sube hasta 10 imágenes (JPG, PNG, WEBP · máx 8MB c/u).",
      f_location: "Ubicación en el mapa",
      f_location_hint: "Haz click en el mapa para marcar la ubicación exacta de la propiedad.",
      f_coords: "Coordenadas",
      upload: "Subir fotos",
      publish: "Publicar",
      save_changes: "Guardar cambios",
      cancel: "Cancelar",
    },
    favorites: {
      title: "Mis favoritos",
      empty: "Todavía no has guardado propiedades.",
    },
    common: {
      loading: "Cargando…",
      required: "Este campo es obligatorio",
      per_month: "/ mes",
    },
    chat: {
      inbox_title: "Mensajes",
      inbox_sub: "Conversaciones sobre propiedades",
      empty_inbox: "Aún no tienes conversaciones.",
      empty_selected: "Selecciona una conversación para ver los mensajes.",
      placeholder: "Escribe un mensaje…",
      send: "Enviar",
      you: "Tú",
      just_now: "ahora",
      login_required: "Inicia sesión para enviar mensajes",
      cannot_message_self: "No puedes enviarte mensajes a ti mismo",
    },
    gate: {
      title: "Regístrate para continuar",
      sub: "Crea tu cuenta o inicia sesión para contactar al anunciante.",
      title_whatsapp: "Contacta por WhatsApp",
      sub_whatsapp: "Regístrate en segundos para hablar directamente con el anunciante.",
      title_phone: "Ver teléfono del anunciante",
      sub_phone: "Regístrate y desbloqueamos el número de contacto al instante.",
      title_chat: "Envía un mensaje interno",
      sub_chat: "Regístrate para iniciar la conversación de forma segura dentro de To2casa.",
      title_email: "Contacta por correo",
      sub_email: "Regístrate para revelar el correo del anunciante.",
      google: "Continuar con Google",
      apple: "Continuar con Apple",
      soon: "Próximamente",
      apple_soon: "Sign in with Apple estará disponible próximamente.",
      or_email: "o con correo",
      legal: "Al continuar aceptas los términos de uso y la política de privacidad de To2casa.",
    },
    projects: {
      title: "Proyectos en Plano",
      sub: "Preventa y proyectos en construcción con planes de pago flexibles y beneficios Confotur.",
      badge_new: "Nuevo",
      empty: "Aún no hay proyectos disponibles.",
      new: "Nuevo proyecto",
      developer: "Constructora",
      price_range: "Rango de precios",
      from: "Desde",
      to: "hasta",
      delivery: "Fecha estimada de entrega",
      payment_plan: "Plan de pago",
      available_units: "Unidades disponibles",
      unit_bedrooms: "{n} habitación",
      unit_bedrooms_plural: "{n} habitaciones",
      unit_studio: "Estudio",
      brochure: "Brochure descargable",
      brochure_download: "Descargar brochure PDF",
      no_brochure: "Sin brochure",
      confotur: "Confotur",
      confotur_desc: "Exención de impuestos por Ley 158-01 de Confotur",
      location: "Ubicación",
      description: "Sobre el proyecto",
      contact: "Contactar constructora",
      months: ["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"],
    },
    proj_form: {
      new_title: "Publicar nuevo proyecto",
      edit_title: "Editar proyecto",
      f_name: "Nombre del proyecto",
      f_developer: "Constructora",
      f_description: "Descripción",
      f_price_min: "Precio desde",
      f_price_max: "Precio hasta",
      f_currency: "Moneda",
      f_delivery_month: "Mes de entrega",
      f_delivery_year: "Año de entrega",
      f_address: "Dirección",
      f_payment: "Plan de pago",
      f_payment_hint: "Agrega las etapas (ej: 10% separación, 40% construcción, 50% entrega). Total debe sumar 100%.",
      f_payment_stage: "Etapa",
      f_payment_percent: "% del total",
      f_payment_add: "Agregar etapa",
      f_units: "Unidades disponibles",
      f_units_hint: "Define las tipologías (habitaciones, precio desde, área).",
      f_unit_bedrooms: "Habitaciones",
      f_unit_price: "Precio desde",
      f_unit_area: "Área (m²)",
      f_unit_desc: "Descripción (opcional)",
      f_unit_add: "Agregar unidad",
      f_confotur: "Beneficios Confotur (Ley 158-01)",
      f_confotur_hint: "Marca si el proyecto está acogido a Confotur (exención de impuestos).",
      f_brochure: "Brochure PDF",
      f_brochure_hint: "Sube el PDF del proyecto (máx 25MB).",
      brochure_upload: "Subir PDF",
      brochure_remove: "Quitar",
      publish: "Publicar proyecto",
      save_changes: "Guardar cambios",
      cancel: "Cancelar",
    },
    dash_tabs: {
      properties: "Propiedades",
      projects: "Proyectos en Plano",
      news: "News",
    },
    news: {
      eyebrow: "to2casa News",
      title: "Noticias e insights inmobiliarios",
      sub: "Guías, análisis de mercado y consejos para comprar, vender o invertir en República Dominicana.",
      empty: "Aún no hay artículos publicados.",
      search: "Buscar artículos…",
      new: "Nuevo artículo",
      read_more: "Leer más",
    },
    news_form: {
      new_title: "Publicar nuevo artículo",
      edit_title: "Editar artículo",
      f_title: "Título",
      f_excerpt: "Resumen (aparece en la lista y en compartidos)",
      f_content: "Contenido",
      f_tags: "Etiquetas",
      f_tags_hint: "Separadas por comas. Ej: mercado, punta-cana, inversion.",
      f_cover: "Foto de portada",
      f_cover_hint: "Imagen destacada del artículo (JPG, PNG, WEBP · máx 8MB).",
      f_publish: "Publicar ahora",
      f_publish_hint: "Si lo desmarcas, quedará como borrador y no aparecerá en la lista pública.",
      publish: "Publicar",
      save: "Guardar cambios",
      cancel: "Cancelar",
    },
    footer: {
      tagline: "Tu mercado inmobiliario.",
      rights: "Todos los derechos reservados.",
    },
  },
  en: {
    nav: {
      properties: "Properties",
      projects: "Off-Plan Projects",
      news: "News",
      favorites: "Favorites",
      dashboard: "Dashboard",
      messages: "Messages",
      login: "Log in",
      register: "Sign up",
      logout: "Log out",
      publish: "List a property",
    },
    bottom: {
      explore: "Explore",
      publish: "List",
      profile: "My Profile",
    },
    hero: {
      eyebrow: "Dominican Republic real estate",
      title: "Find your next\nproperty here.",
      sub: "Houses, apartments, villas and land across the Dominican Republic. List, save favorites and contact agents — all in one place.",
      cta_browse: "Browse listings",
      cta_publish: "List a property",
    },
    home: {
      featured: "Featured this week",
      featured_sub: "Hand-picked by our verified agents.",
      why_title: "One platform. Two roles.",
      why_sub: "Built for serious buyers and agents who want to close faster.",
      role_buscador_title: "For buyers",
      role_buscador_desc: "Browse, save favorites and message agents directly. No hidden fees.",
      role_agente_title: "For agents & owners",
      role_agente_desc: "Publish your listings with unlimited photos and manage your inventory from a private dashboard.",
      cta_signup: "Create your account",
    },
    filters: {
      title: "Filter properties",
      type: "Type",
      any: "Any",
      transaction: "Deal",
      sale: "For sale",
      rent: "For rent",
      min_price: "Min price",
      max_price: "Max price",
      bedrooms: "Bedrooms",
      search: "Search by title or address",
      apply: "Apply filters",
      clear: "Clear",
      results: "results",
      view_list: "List",
      view_map: "Map",
      near_me: "Near me",
      near_me_active: "Near me · {km} km",
      near_me_clear: "Clear",
      near_me_locating: "Locating…",
      near_me_denied: "Couldn't get your location. Enable permissions and try again.",
      near_me_unsupported: "Your browser doesn't support geolocation.",
      radius: "Radius",
    },
    property: {
      bedrooms: "Bedrooms",
      bathrooms: "Bathrooms",
      square_meters: "sq m",
      type: "Type",
      address: "Address",
      description: "Description",
      agent: "Agent",
      contact: "Contact by email",
      contact_whatsapp: "Contact via WhatsApp",
      contact_chat: "Send internal message",
      view_phone: "View phone",
      call: "Call",
      save: "Save",
      saved: "Saved",
      published_by: "Listed by",
      whatsapp_prefill: "Hi, I'm interested in \"{title}\" (ID: {id}). Can we talk?",
    },
    types: {
      casa: "House",
      apartamento: "Apartment",
      villa: "Villa",
      local: "Commercial",
      terreno: "Land",
      oficina: "Office",
    },
    auth: {
      login_title: "Welcome back",
      login_sub: "Sign in to your To2casa account",
      register_title: "Create your account",
      register_sub: "Join and list or save properties",
      email: "Email",
      password: "Password",
      name: "Full name",
      phone: "WhatsApp (with country code)",
      phone_hint: "Optional for buyers · Recommended for agents",
      role: "I am a",
      role_buscador: "Buyer",
      role_agente: "Agent / Owner",
      submit_login: "Sign in",
      submit_register: "Create account",
      or: "or continue with",
      google: "Continue with Google",
      have_account: "Already have an account?",
      no_account: "Don't have an account?",
      go_login: "Log in",
      go_register: "Sign up",
    },
    dashboard: {
      title: "Agent dashboard",
      subtitle: "Manage your listings",
      new: "New property",
      empty: "You haven't listed any properties yet.",
      edit: "Edit",
      delete: "Delete",
      confirm_delete: "Delete this property?",
      views: "views",
    },
    form: {
      new_title: "List a new property",
      edit_title: "Edit property",
      f_title: "Title",
      f_price: "Price",
      f_currency: "Currency",
      f_address: "Address",
      f_bedrooms: "Bedrooms",
      f_bathrooms: "Bathrooms",
      f_sqm: "Square meters",
      f_type: "Property type",
      f_transaction: "Deal type",
      f_description: "Description",
      f_photos: "Photos",
      f_photos_hint: "Upload up to 10 images (JPG, PNG, WEBP · max 8MB each).",
      f_location: "Location on the map",
      f_location_hint: "Click on the map to mark the exact location.",
      f_coords: "Coordinates",
      upload: "Upload photos",
      publish: "Publish",
      save_changes: "Save changes",
      cancel: "Cancel",
    },
    favorites: {
      title: "My favorites",
      empty: "You haven't saved any properties yet.",
    },
    common: {
      loading: "Loading…",
      required: "This field is required",
      per_month: "/ month",
    },
    chat: {
      inbox_title: "Messages",
      inbox_sub: "Conversations about properties",
      empty_inbox: "You have no conversations yet.",
      empty_selected: "Select a conversation to view messages.",
      placeholder: "Write a message…",
      send: "Send",
      you: "You",
      just_now: "just now",
      login_required: "Log in to send messages",
      cannot_message_self: "You can't message yourself",
    },
    gate: {
      title: "Sign up to continue",
      sub: "Create an account or log in to contact the lister.",
      title_whatsapp: "Contact via WhatsApp",
      sub_whatsapp: "Sign up in seconds to talk directly with the lister.",
      title_phone: "See lister's phone",
      sub_phone: "Sign up and we'll reveal the contact number instantly.",
      title_chat: "Send an internal message",
      sub_chat: "Sign up to start the conversation safely inside To2casa.",
      title_email: "Contact by email",
      sub_email: "Sign up to reveal the lister's email.",
      google: "Continue with Google",
      apple: "Continue with Apple",
      soon: "Soon",
      apple_soon: "Sign in with Apple is coming soon.",
      or_email: "or with email",
      legal: "By continuing you accept To2casa's terms of use and privacy policy.",
    },
    projects: {
      title: "Off-Plan Projects",
      sub: "Pre-sale and under-construction projects with flexible payment plans and Confotur benefits.",
      badge_new: "New",
      empty: "No projects available yet.",
      new: "New project",
      developer: "Developer",
      price_range: "Price range",
      from: "From",
      to: "to",
      delivery: "Estimated delivery",
      payment_plan: "Payment plan",
      available_units: "Available units",
      unit_bedrooms: "{n} bedroom",
      unit_bedrooms_plural: "{n} bedrooms",
      unit_studio: "Studio",
      brochure: "Downloadable brochure",
      brochure_download: "Download PDF brochure",
      no_brochure: "No brochure",
      confotur: "Confotur",
      confotur_desc: "Tax exemption under Confotur Law 158-01",
      location: "Location",
      description: "About the project",
      contact: "Contact developer",
      months: ["January","February","March","April","May","June","July","August","September","October","November","December"],
    },
    proj_form: {
      new_title: "List new project",
      edit_title: "Edit project",
      f_name: "Project name",
      f_developer: "Developer",
      f_description: "Description",
      f_price_min: "Price from",
      f_price_max: "Price to",
      f_currency: "Currency",
      f_delivery_month: "Delivery month",
      f_delivery_year: "Delivery year",
      f_address: "Address",
      f_payment: "Payment plan",
      f_payment_hint: "Add the stages (e.g. 10% deposit, 40% construction, 50% delivery). Total should sum to 100%.",
      f_payment_stage: "Stage",
      f_payment_percent: "% of total",
      f_payment_add: "Add stage",
      f_units: "Available units",
      f_units_hint: "Define unit types (bedrooms, starting price, area).",
      f_unit_bedrooms: "Bedrooms",
      f_unit_price: "Price from",
      f_unit_area: "Area (sq m)",
      f_unit_desc: "Description (optional)",
      f_unit_add: "Add unit",
      f_confotur: "Confotur benefits (Law 158-01)",
      f_confotur_hint: "Mark if the project qualifies for Confotur tax exemption.",
      f_brochure: "PDF Brochure",
      f_brochure_hint: "Upload the project PDF (max 25MB).",
      brochure_upload: "Upload PDF",
      brochure_remove: "Remove",
      publish: "Publish project",
      save_changes: "Save changes",
      cancel: "Cancel",
    },
    dash_tabs: {
      properties: "Properties",
      projects: "Off-Plan Projects",
      news: "News",
    },
    news: {
      eyebrow: "to2casa News",
      title: "Real-estate news & insights",
      sub: "Guides, market analysis and tips to buy, sell or invest in the Dominican Republic.",
      empty: "No articles published yet.",
      search: "Search articles…",
      new: "New article",
      read_more: "Read more",
    },
    news_form: {
      new_title: "Publish new article",
      edit_title: "Edit article",
      f_title: "Title",
      f_excerpt: "Excerpt (shows in the list and shares)",
      f_content: "Content",
      f_tags: "Tags",
      f_tags_hint: "Comma-separated. Ex: market, punta-cana, investment.",
      f_cover: "Cover photo",
      f_cover_hint: "Featured image of the article (JPG, PNG, WEBP · max 8MB).",
      f_publish: "Publish now",
      f_publish_hint: "If unchecked, it will remain as a draft and won't appear on the public list.",
      publish: "Publish",
      save: "Save changes",
      cancel: "Cancel",
    },
    footer: {
      tagline: "Your real estate marketplace.",
      rights: "All rights reserved.",
    },
  },
};
